import { Button } from '@/components/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { logger } from '@/lib/logger'
import { useDevicesStore } from '@/stores/devices-store'
import { Smartphone } from 'lucide-react'

export function AppHeader() {
    const currentDevice = useDevicesStore((state) => state.currentDevice)
    const availableDevices = useDevicesStore((state) => state.availableDevices)
    const setSelectedDevice = useDevicesStore((state) => state.setSelectedDevice)

    logger.debug('Header rendered', {
        currentDevice: currentDevice?.name,
        deviceCount: availableDevices.length
    })

    return (
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4 bg-white">
            <SidebarTrigger />

            <div className="flex flex-1 items-center justify-start">
                <div className="flex items-center gap-4">

                    {/* Device Selector */}
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="outline" size="sm" className="gap-2">
                                <Smartphone className="h-4 w-4" />
                                <span className="hidden sm:inline">{currentDevice?.customerName || currentDevice?.name || 'Device auswählen'}</span>
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="start" className="w-56">
                            <DropdownMenuLabel>Verfügbare Geräte</DropdownMenuLabel>
                            <DropdownMenuSeparator />
                            {availableDevices.length === 0 ? (
                                <DropdownMenuItem disabled>
                                    Keine Geräte verfügbar
                                </DropdownMenuItem>
                            ) : (
                                availableDevices.map((device) => (
                                    <DropdownMenuItem
                                        key={device.id}
                                        onClick={() => setSelectedDevice(device, device.deviceId)}
                                        className={currentDevice?.id === device.id ? 'bg-accent' : ''}
                                    >
                                        <div className="flex flex-col">
                                            <span className="font-medium">{device.customerName || device.name || 'Unbenanntes Gerät'}</span>
                                            <span className="text-xs text-muted-foreground">ID: {device.deviceId}</span>
                                        </div>
                                    </DropdownMenuItem>
                                ))
                            )}
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
            </div>
        </header>
    )
}